import { createBrowserHistory } from 'history';

const createHistory = () => createBrowserHistory();

export default createHistory;
